export default __webpack_public_path__ + "static/media/om_mock.65896ba9.png";